__webpack_require__.p = "https://grading-template-builder.lotfits-dev.com/";